import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { SHOW_ERROR, RESIZE, CANCEL, INITIALIZE } from '../ducks/ApplicationDucks';
import { fetchDocuments } from '../ducks/DocumentsDucks';
import { fetchDocumentTypes } from '../ducks/DocumentTypesDucks';

function cancel(action) {
  if (window.parent) {
    window.parent.postMessage(action, '*');
  }
}

function* initialize({ settings }) {

  if(settings.workflowInstanceId) {
    yield put(fetchDocumentTypes(settings.workflowInstanceId));
    yield put(fetchDocuments(settings.workflowInstanceId));
  }

}

function resize() {

  document.body.style.overflow = 'hidden';

  setTimeout(
    () => {
      if (window.parent) {
        window.parent.postMessage({
          type: RESIZE,
          height: window.document.body.offsetHeight
        }, '*');
      }
      setTimeout(() => {
        document.body.style.overflow = 'auto';
      }, 250);
    },
    100
  )
}

function showError(action) {
  if (window.parent) {
    window.parent.postMessage(action, '*');
  }
}

function* cancelSagas() {
  yield takeEvery(CANCEL, cancel);
}

function* initializeSagas() {
  yield takeEvery(INITIALIZE, initialize);
}

function* resizeSagas() {
  yield takeEvery(RESIZE, resize);
}

function* showErrorSagas() {
  yield takeEvery(SHOW_ERROR, showError);
}

export default function* () {
  yield all([
    fork(cancelSagas),
    fork(initializeSagas),
    fork(resizeSagas),
    fork(showErrorSagas)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/ApplicationSagas.js